import { useEffect } from "react";
import { ArrowLeft, Home } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Link, useLocation } from "@tanstack/react-router";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <main className="relative m-auto min-h-screen overflow-hidden">
      <section className="relative flex min-h-screen items-center justify-center py-12">
        <div>
          {/* <div className="border-border/60 bg-card/75 text-muted-foreground shadow-soft mb-5 inline-flex items-center gap-2 rounded-full border [background-image:var(--gradient-card)] px-4 py-2 text-sm font-medium backdrop-blur-xl">
              <Compass className="text-primary size-4" />
              Whale, that route is missing
            </div> */}

          <p className="text-muted-foreground mb-3 text-sm font-medium tracking-[0.32em] uppercase">
            404 / Page not found
          </p>
          <h1 className="max-w-xl text-5xl leading-none font-extrabold tracking-tight md:text-7xl">
            This page <span className="text-primary">swam away.</span>
          </h1>
          <p className="text-muted-foreground mt-5 max-w-lg text-lg leading-relaxed">
            The route{" "}
            <span className="text-foreground font-semibold">
              {location.pathname}
            </span>{" "}
            doesn&apos;t exist, was renamed, or never surfaced.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button
              onClick={() => window.history.back()}
              className="bg-primary shadow-whale flex w-fit gap-1.5 text-white transition-all duration-300 hover:-translate-y-0.5 hover:brightness-105 sm:min-w-48"
            >
              <ArrowLeft />
              Go Back
            </Button>
            <Button
              asChild
              className="border-border/70 bg-card/80 text-foreground shadow-soft hover:bg-secondary flex w-fit gap-1.5 border transition-all duration-300 sm:min-w-48"
            >
              <Link to="/">
                <Home />
                Return Home
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
